(() => {
  if (customElements.get('rr-campaign-gallery')) return;
  class RRCampaignGallery extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('dragstart', event => event.preventDefault(), options);
      this.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        if (this.closest('.rr-campaign-story--products') && event.target.closest('dialog, button, input, select, textarea, label')) return;
        this.suppressClick = false;
        this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, scroll: this.scrollLeft, dragging: false };
      }, options);
      this.addEventListener('pointermove', event => {
        const gesture = this.gesture;
        if (!gesture || gesture.id !== event.pointerId) return;
        const dx = event.clientX - gesture.x;
        const dy = event.clientY - gesture.y;
        if (!gesture.dragging && Math.abs(dx) > 6 && Math.abs(dx) > Math.abs(dy)) {
          gesture.dragging = true;
          this.classList.add('is-dragging');
          this.setPointerCapture(event.pointerId);
        }
        if (!gesture.dragging) return;
        event.preventDefault();
        this.scrollLeft = gesture.scroll - dx;
      }, options);
      this.addEventListener('pointerup', () => this.finishDrag(), options);
      this.addEventListener('pointercancel', () => this.finishDrag(), options);
      this.addEventListener('lostpointercapture', () => this.finishDrag(), options);
      this.addEventListener('pointerleave', () => {
        if (!this.gesture?.dragging) this.gesture = null;
      }, options);
      this.addEventListener('click', event => {
        if (!this.suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        this.suppressClick = false;
      }, { ...options, capture: true });
      this.addEventListener('keydown', event => {
        if (event.target !== this || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const step = this.querySelector('.rr-campaign-story__item')?.getBoundingClientRect().width || this.clientWidth * .7;
        const gap = parseFloat(getComputedStyle(this).columnGap) || 0;
        const left = event.key === 'Home' ? 0 : event.key === 'End' ? this.scrollWidth : this.scrollLeft + (step + gap) * (event.key === 'ArrowRight' ? 1 : -1);
        this.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const item = event.target.closest('.rr-campaign-story__item');
        if (item) this.scrollLeft += item.getBoundingClientRect().left - this.getBoundingClientRect().left;
      }, options);
    }
    finishDrag() {
      const gesture = this.gesture;
      if (!gesture) return;
      this.gesture = null;
      this.suppressClick = gesture.dragging;
      if (this.hasPointerCapture(gesture.id)) this.releasePointerCapture(gesture.id);
      this.classList.remove('is-dragging');
    }
    disconnectedCallback() {
      this.finishDrag();
      this.controller?.abort();
      this.controller = null;
    }
  }
  customElements.define('rr-campaign-gallery', RRCampaignGallery);
})();
